var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "my-0",
    style: [_vm.computedColor]
  }, [_c('v-col', {
    staticClass: "d-flex align-center py-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.prependIcon ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.disabledBtn
    },
    on: {
      "click": function click($event) {
        return _vm.clickIcon($event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.prependIcon) + " ")]) : _vm._e(), _c('div', {
    staticClass: "title-text",
    class: {
      'text-center': !_vm.textStart,
      'inline': _vm.inline,
      'required': _vm.required
    },
    style: {
      'font-weight': _vm.fontWeight,
      'font-size': _vm.fontSize + 'px'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm.appendIcon ? _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.disabledBtn
    },
    on: {
      "click": function click($event) {
        return _vm.clickIcon($event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.appendIcon) + " ")]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }